/* eslint-disable kf/const-naming-convention */

export const ACCOUNT_STATUS = {
  TRIAL: "Trial",
  NFR: "NFR",
  ACTIVE: "Active"
};

export const USER_TYPES = {
  ADMIN: "Admin",
  USER: "User"
};

export const ACCOUNT_TYPES = {
  STANDARD_ACCOUNT: 0,
  DEVELOPMENT_ACCOUNT: 10,
  PRINCIPAL_ACCOUNT: 20,
  SUPER_ACCOUNT: 50,
  SYSTEM_ACCOUNT: 90
};

export const ROLES = {
  SUPER_ADMIN: "Super Admin",
  USER_ADMIN: "User Admin",
  BILLING_ADMIN: "Billing Admin",
  CONNECTOR_ADMIN: "Connector admin",
  CONNECTOR_DEVELOPER: "Connector developer",
  USER: "User"
};

export const SYSTEM_ROLES = {
  SUPER_ADMIN: "_super_admin",
  USER_ADMIN: "_user_admin",
  BILLING_ADMIN: "_billing_admin",
  IAM_ADMIN: "_iam_admin",
  APPSTORE_ADMIN: "_app_store_admin",
  CONNECTOR_ADMIN: "_connector_admin",
  CONNECTOR_DEVELOPER: "_connector_developer"
};

export const PRODUCTS = {
  PROCESS: "Process",
  DATASET: "Dataset",
  PROJECT: "Project",
  CASE: "Case",
  INTEGRATION: "Integration",
  LIST: "List",
  APPLICATION: "Application",
  PORTAL: "Portal",
  ANALYTICS: "Analytics"
};

export const AccountErrors = {
  TrialExpired: "TrialExpired",
  DunningExpired: "DunningExpired"
};

export const BillingEvents = {
  LISTEN_SUBSCRIPTION_CARD: "listenSubscriptionCard",
  REMOVE_SUBSCRIPTION_CARD_LISTENER: "removeSubscriptionListener"
};

export const USER_KIND = {
  USER: "User",
  GROUP: "Group",
  ROLE: "Role",
  SERVICE_ACCOUNT: "ServiceAccount",
  APP_ROLE: "AppRole"
};

export const USER_POPUP_OPTIONS = {
  MESSAGE: "message",
  PROFILE: "profile"
};

export const ENVIRONMENT_TYPES = {
  DEVELOPMENT: "Development",
  TEST: "Test",
  PRODUCTION: "Production"
};

export const ADMIN_MODULE = "Admin";

export const ADMIN_RESOURCES = {
  USER_PROVISIONING: "UserProvisioning",
  ACCOUNT_DETAILS: "AccountDetails",
  ACCOUNT_CUSTOMIZATION: "AccountCustomization",
  CONNECTED_DOMAIN: "ConnectedDomain",
  FORMAT_SETTING: "FormatSetting",
  HOLIDAY_SETTING: "HolidaySetting",
  UPLOAD_SETTING: "UploadSetting",
  GEOLOCATION_SETTING: "GeoLocationSetting",
  SIGNIN_PREFERENCE: "SigninPreference",
  SIGNUP_PREFERENCE: "SignupPreference",
  ACCESS_KEY: "AccessKey",
  IMPERSONATION_SECURITY: "ImpersonationSecurity",
  USER_MANAGEMENT: "UserManagement",
  GROUP_MANAGEMENT: "GroupManagement",
  ACCOUNT_AUDITLOG: "AccountAuditLog",
  USER_AUDITLOG: "UserAuditLog",
  BILLING: "Billing",
  ENVIRONMENTS: "Environment",
  NOTIFICATION_SETTING: "NotificationSetting",
  FLOW_SETTING: "FlowSetting",
  TASK_DELEGATION: "TaskDelegation",
  SERVICE_ACCOUNT: "ServiceAccount",
  APPSTORE: "AppStore",
  GOVERNANCE: "Governance",
  BACKUP: "Backup",
  BOT_SETTING: "BotSetting",
  CONNECTOR: "Connector"
};

export const ADMIN_ACTIONS = {
  READ: "Read",
  SYNC: "Sync",
  UPDATE: "Update",
  EXPORT: "Export",
  CREATE: "Create",
  RESETPASSWORD: "ResetPassword",
  ACTIVATE: "Activate",
  DEACTIVATE: "Deactivate",
  RESENDVERIFICATION: "ResendVerification",
  UNLOCK: "Unlock",
  UPDATE2FA: "Update2FA",
  DELETE: "Delete",
  UPDATEROLE: "UpdateRole",
  INVOICE: "Invoice",
  INSTALL: "Install",
  USER: "ViewUser",
  GROUP: "ViewGroup",
  FLOW: "ViewFlow",
  MIGRATE: "Migrate",
  DEPRECATE: "Deprecate",
  APPROVE: "Approve",
  REJECT: "Reject",
  CLONE: "Clone"
};
